require([
	'jquery'
], function(
	$
	) {

	'use strict';


	if ( !window.requestAnimationFrame ) {
		window.requestAnimationFrame = ( function() { 
			return window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function( callback, element ) {window.setTimeout( callback, 1000 / 60 ); }; } )();
	}


	var lastPosition = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
	var reachedBottomFirstTime = true;


	function reachedBottom(lastPosition){

		var body = document.body, html = document.documentElement;
		var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight )-$(window).height();

		if(lastPosition < height){
			$('html').removeClass('reachedBottom');
			// console.log('reachedBottom');
		} else {

			if(reachedBottomFirstTime){
				reachedBottomFirstTime = true;
				$('html').addClass('reachedBottom');
				// console.log('reachedBottom');
			}
		}

		if(lastPosition >= 1){
			$('html').removeClass('reachedTop');
			// console.log('reachedTop');
		} else {
			$('html').addClass('reachedTop');
			// console.log('reachedTop');
		}

		if(!$('html').hasClass('reachedTop') && !$('html').hasClass('reachedBottom')){
			$('html').addClass('inBetweenScroll');
			// console.log('inBetweenScroll');
		} else {
			$('html').removeClass('inBetweenScroll');
			// console.log('inBetweenScroll');
		}
	}


	var loop = function() {
		requestAnimationFrame(loop);
		var check = (document.documentElement && document.documentElement.scrollTop) || document.body.scrollTop;
		if(lastPosition !== check) {
			lastPosition = check;
			reachedBottom(lastPosition);
		}
	}


	reachedBottom(lastPosition);
	loop();


	// MENU

	var menuOffset = 0;

	function lockBody(lock, timeout) {
		setTimeout(function() {
			if (lock) {
				$('#main, #footer').addClass('noscroll');
				// console.log('lock body');
			} else {
				$('#main, #footer').removeClass('noscroll');
				// console.log('release body');
			}
		}, timeout);
	}

	function closeMenu() {
		// console.log('closeMenu');
		$('html').removeClass('showMenu');
		$('.menu__entry').next().removeClass('is-active');
		lockBody(false, 100);
		$('body, html').scrollTop(menuOffset); // scroll to previous position
		menuOffset = 0; // reset scroll position
		setTimeout(function() {
			$('html').removeClass('menufixed');
		}, 300);
		setTimeout(function() {
			$('html').removeClass('transitionMenu');
		}, 500);
	}

	function openMenu() {
		// console.log('openMenu');
		$('html').addClass('showMenu');
		lockBody(true, 100);
		menuOffset = window.pageYOffset; // get current scroll position
		setTimeout(function() {
			$('html').addClass('menufixed');
		}, 300);
			$('html').addClass('transitionMenu');
	}

	$('.js_menu').click(function(e) {
		e.preventDefault();
		e.stopPropagation();
		// console.log('js_menu');
		$(this).toggleClass('open');

		if ($(this).hasClass('open')) {
			openMenu();
		} else {
			closeMenu();
		}
	});

});
define("root/Assets/Templates/Html/FullHeader/Js/FullHeader", function(){});

